module.exports = __webpack_public_path__ + "open-sans-v17-latin-700.woff?1f85e92d8ff443980bc0f83ad7b23b60";